<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <span>{{info.courseName}}开课详情</span>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form ref="form" :inline="true" :model="form" label-width="90px">
        <el-form-item label="">
          <el-select
            v-model="form.semester"
            clearable
            placeholder="请选择学期学年"
          >
            <el-option
              v-for="item in semesterList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="">
          <el-input
            v-model="form.name"
            clearable
            placeholder="请输入开课学校名称"
          />
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="getDataList"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 校内教师 -->
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="a" label="开课学校" align="center">
          </el-table-column>
          <el-table-column prop="b" label="授课教师" align="center">
          </el-table-column>
          
          <el-table-column prop="c" label="课程覆盖年级" align="center">
          </el-table-column>
          <el-table-column prop="d" label="课时总数" align="center">
          </el-table-column>
          <el-table-column prop="e" label="上课时间" align="center">
          </el-table-column>
          <el-table-column prop="f" label="上课地点" align="center">
          </el-table-column>
          <el-table-column prop="g" label="招生人数" align="center">
          </el-table-column>
          <el-table-column prop="h" label="报名人数" align="center">
          </el-table-column>
        </el-table>
        <div class="pagination">
          <!--分页组件-->
          <el-pagination
            background
            :current-page="page.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.pageSize"
            :total="page.totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index";
export default {
  props: {
    info: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      form: {
        semester:"",
        name:"",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList"))||[],
      semesterList: [
        {id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
      ],
      tableData: [
        {a:'汉阳区实验小学',b:'夏咏歌',c:"一年级、二年级",d:'200',e:'每周一第六节每周四第七节',f:'多功能教室',g:'30',h:'28'},
        {a:'青山区第七小学',b:'胡欣怡',c:"一年级、二年级、三年级",d:'200',e:'每周三第五节',f:'三年级1班',g:'30',h:'28'},
        {a:'光谷第二小学',b:'赖元基',c:"一年级、二年级",d:'200',e:'每周三第六节',f:'一年级2班',g:'30',h:'28'},
        {a:'蔡甸区第十小学',b:'文元武',c:"一年级、二年级",d:'200',e:'每周一第六节每周四第七节',f:'一年级5班',g:'30',h:'28'},
      ],
      school_info: JSON.parse(sessionStorage.getItem("classList"))||[],
    };
  },
  watch: {
  
  },
  mounted() {},
  created() {
    this.getDataList();
    this.campusList = this.school_info.slice();
  },
  methods: {
    async getDataList() {
      let params = {
        schoolYearSemester: this.form.schoolYearSemester,
        gradeId: this.form.gradeId,
        courseName: this.form.courseName,
        extOrgName: this.info.extOrgName,
        typeId: "",
        teacherId: "",
        orgId:sessionStorage.getItem('orgId'),
        platformCode:sessionStorage.getItem('platformCode'),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      // var { data, code } = await api.handleCourseList(params);
      // console.log("获取列表数据---", data, code);
      // if (code == "0") {
      //   this.tableData = data.list;
      //   this.page.totalPage = data.total;
      // }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },

    toIndex() {
      this.$emit("go-home");
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 189px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
